export function isObjectEmpty(objectName) {
  return JSON.stringify(objectName) === '{}';
}
